var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddShoppingCartFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.65 16.8v-6.15h-6.2V7.8h6.2V1.65h2.85V7.8h6.15v2.85H26.5v6.15ZM14.6 44.45q-1.5 0-2.525-1.05t-1.025-2.5q0-1.45 1.05-2.475 1.05-1.025 2.5-1.025t2.475 1.025Q18.1 39.45 18.1 40.9q0 1.5-1.025 2.525T14.6 44.45Zm20.05 0q-1.45 0-2.475-1.05-1.025-1.05-1.025-2.5t1.025-2.475Q33.2 37.4 34.65 37.4q1.5 0 2.5 1.025t1 2.475q0 1.5-1.025 2.525T34.65 44.45ZM14.6 34.1q-2.35 0-3.5-1.925t0-3.975l2.9-5.25-7.2-15.4H2.75V3.6H9.4l8.15 17.55h14.4l7.5-13.35 3.5 1.85-7.5 13.5q-.6.9-1.425 1.45-.825.55-2.075.55H17.4l-2.85 5H38.7v3.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddShoppingCartFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/add_shopping_cart_FILL1_wght700_GRAD200_opsz48.4f1c7e51695fdf82f976cae311e90257.svg";
export { ForwardRef as ReactComponent };